import styles from './ActionButton.module.css';

interface ActionButtonProps {
	text: string;
	onClick: () => void;
}

export const ActionButton = ({ text, onClick }: ActionButtonProps) => {
	return (
		<button className={styles.button} onClick={onClick}>
			{text}
		</button>
	);
};
